export default "__VITE_ASSET__f65dd88f__"